export const statusToStyleMap = {
    pending: 'warning',
    approved: 'success',
    accepted: 'success',
    rejected: 'error',
    refused: 'error',
    executed: 'success',

    new: 'info',
    initialize: 'info',
    sum_blocked: 'warning',
    awaiting_3ds: 'warning',
    processed: 'success',
    partially_refunded: 'warning',
    refunded: 'success',
    cancelled: 'error',
    awaiting_processing: 'warning',
    awaiting_withdraw: 'warning',
    withdrawed: 'success',
    withdraw_cancelled: 'error',
    awaiting_confirmation: 'warning',

    open: 'info',
    payment_initiated: 'info',
    payment_final: 'error',
    payment_success: 'success',
    expired: 'error',

    init: 'info',
    retry: 'warning',
    success: 'success',
    failed: 'error',

    makepayment_error: 'error',
    paymentcallback: 'info',
    makepayment_awaiting_3ds: 'warning',
    makepayment_refused: 'error',

    cascade_current: 'info',
    cascade_cancelled: 'error',
    cascade_final: 'success',

    ready: 'success',

};

export const mapStatusToStyle = (status) =>
    statusToStyleMap[status] || 'primary';

export const formatName = (fn, ln) => {
    if (!fn && !ln) return 'Unknown';
    return `${fn} ${ln}`;
};
export const extractValues = (obj, extractedKeys) => {
    return extractedKeys.map((key) => obj?.[key] ?? '').join(' - ');
};

export const getExtractValue = (item, show, nestedObject = null, secondaryObject = null) => {
    if (!show) return '';

    const keys = show.split('+');

    if (nestedObject) {
        if (secondaryObject) {
            const secondaryValue = extractValues(
                item[secondaryObject] || {},
                keys
            );
            const nestedValue = extractValues(item[nestedObject] || {}, keys);
            return `${secondaryValue} - ${nestedValue}`;
        }
        return extractValues(item[nestedObject] || {}, keys);
    }

    return extractValues(item, keys);
};

export const formatController = (name) => {
    // Remove 'public' prefix if it exists
    // name = name.replace(/^public/, '');
    // Convert the first character to lowercase if needed
    name = name.charAt(0).toLowerCase() + name.slice(1);
    // Replace uppercase letters with '-lowercase' and convert all to lowercase
    name = name.replace(/([A-Z])/g, '-$1').toLowerCase();
    return name;
};

export function getNestedValue(obj, path) {
    if (!obj || !path) return undefined;
    return path
        .split('.')
        .reduce(
            (acc, key) =>
                acc && acc[key] !== undefined ? acc[key] : undefined,
            obj
        );
}
const jsonRegex = /^[{[].*[}\]]$/;
export const isValidJSON = (str) => {
    if (typeof str !== 'string' || !jsonRegex.test(str.trim())) return false;
    try {
        JSON.parse(str);
        return true;
    } catch {
        return false;
    }
};
